<div class="container-fluid my-2">
  <div class="row">
    <div class="col"></div>
    <div class="col-auto">
      <i class="bi bi-x-lg fs-22 cursor-select" (click)="close()"></i>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <app-client-vendor-search
        [showAdvancedSearch]="false"
        [companyTypeSearchText]="companyTypeSearchText"
        [showTradeSelection]="showTradeSelection"
        (searchEvent)="search($event)"
      ></app-client-vendor-search>
    </div>
  </div>
</div>
